import { array as arrayCodec } from "../../../../../shared/src/codecs/types/array";
import { required } from "../../../../../shared/src/codecs/types/required";
import { GuideRead, TGuideRead } from "../../../../../domain/codecs/GuideRead";

const MyReadsResponse = required({ rows: arrayCodec(GuideRead) });
const PostReadResponse = GuideRead;

export const fetchMyGuideReads = async (): Promise<Array<TGuideRead>> => {
    const res = await fetch(`${env.REACT_APP_API_URL}/web/guides/reads/me`, {
        credentials: "include",
        headers: { accept: "application/json", "content-type": "application/json" },
    });
    if (!res.ok) throw new Error(`get my guide reads failed: ${res.status}`);
    const raw: unknown = await res.json();
    const decoded = MyReadsResponse.decode(raw);
    if (decoded._tag !== "Right") throw new Error("my guide reads response failed validation");
    return decoded.right.rows;
};

export const postGuideRead = async (product: string, slug: string, contentHash: string): Promise<TGuideRead> => {
    const res = await fetch(`${env.REACT_APP_API_URL}/web/guides/reads`, {
        method: "POST",
        credentials: "include",
        headers: { accept: "application/json", "content-type": "application/json" },
        body: JSON.stringify({ product, slug, content_hash: contentHash }),
    });
    if (!res.ok) throw new Error(`post guide read failed: ${res.status}`);
    const raw: unknown = await res.json();
    const decoded = PostReadResponse.decode(raw);
    if (decoded._tag !== "Right") throw new Error("post guide read response failed validation");
    return decoded.right;
};

export type TGuideReadState =
    | { kind: "unread" }
    | { kind: "read"; read_at: string }
    | { kind: "stale"; read_at: string };

export const computeReadState = (
    reads: Array<TGuideRead>,
    product: string,
    slug: string,
    currentHash: string,
): TGuideReadState => {
    const matching = reads.filter((r) => r.product === product && r.slug === slug);
    if (matching.length === 0) return { kind: "unread" };
    const currentRead = matching.find((r) => r.content_hash === currentHash);
    if (currentRead) return { kind: "read", read_at: currentRead.read_at };
    return { kind: "stale", read_at: matching[0].read_at };
};
